import styled from 'styled-components';

import LoyaltyPointsIcon from 'components/icons/loyalty-points-icon';
import LoyaltyRewardsLogo from 'pages/loyalty/loyalty-rewards-logo';

export const Wrapper = styled.div`
  width: 100%;
  background-color: ${Styles.color.tertiary};
  position: fixed;
  z-index: ${Styles.zIndex.overlay + 100};
  ${Styles.desktop`
    margin-top: 0;
  `}
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 1200px;
  min-height: 2.5rem;
  margin: 0 auto;
  width: 100%;
  align-items: center;
  border-style: solid;
  border-color: transparent;
  border-width: 0 0.75rem;
  ${Styles.desktop`
    border-width: 0 4.65rem;
  `}
`;

export const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  &:first-child {
    margin: 0 0.5rem 0 0;
  }
`;

export const PointsText = styled.p`
  width: max-content;
  color: ${Styles.color.white};
  font-size: 0.875rem;
  margin: 0;
`;

export const PointsNumber = styled.p`
  color: ${Styles.color.white};
  font-size: 1rem;
  font-weight: ${Styles.fontWeight.heavy};
  font-family: ${Styles.fontFamily.brand};
  margin: 0 0 0 0.5rem;
  text-transform: lowercase;
`;

export const StyledPointsIcon = styled(LoyaltyPointsIcon)`
  width: 1.1rem;
`;

export const StyledRewardsLogo = styled(LoyaltyRewardsLogo)`
  width: 6.35rem;
  margin: 0 0.25rem 0 0;
`;
